import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Paper, FlatButton, FontIcon, CircularProgress } from 'material-ui';
import flowRight from 'lodash/flowRight';

import { normalizeNumber } from 'utils/normalize';
import { update, setStatus } from 'actions/EmployeeBank';
import {
  ACCOUNT_FIXED as FIXED,
  ACCOUNT_SAVING as SAVING,
  ACCOUNT_EDIT as EDIT,
} from 'constants/statuses';
import styles from './styles/TaxCard';
import TField from './TField';
import { validateBankAccount } from './helpers';

const EmployeeBankAccount = (props) => {
  const { status, invalid } = props;

  const onEdit = () => props.setStatus({ id: props.account.EmployeeMasterBankID, value: EDIT });
  const onSave = (data) => {
    props.update(data);
  };

  const editIcon = status === SAVING
    ? <CircularProgress style={{ lineHeight: '14px' }} size={14} thickness={2} />
    : <FontIcon style={{ fontSize: 16 }} className="material-icons">edit</FontIcon>;
  const btnIcon = status === EDIT ? <FontIcon style={{ fontSize: 16 }} className="material-icons">save</FontIcon> : editIcon;

  return (
    <Paper>
      <form style={{ ...styles.container, paddingTop: 16 }}>
        <Field
          name="BankID"
          component={TField}
          label={<FormattedMessage id="bank.branch" />}
          customStyle={{ width: 120 }}
          disabled={status === FIXED}
          pad={4}
          maxLength="4"
          normalize={normalizeNumber}
        />
        <Field
          name="BankAccountLedger"
          component={TField}
          label={<FormattedMessage id="bank.ledger" />}
          customStyle={{ width: 120 }}
          disabled={status === FIXED}
          pad={2}
          maxLength="2"
          normalize={normalizeNumber}
        />
        <Field
          name="BankAccountNR"
          component={TField}
          label={<FormattedMessage id="bank.account" />}
          customStyle={{ width: 120 }}
          disabled={status === FIXED}
          pad={6}
          maxLength="6"
          normalize={normalizeNumber}
        />
        <FlatButton
          style={styles.editButton}
          labelStyle={styles.editButtonLabel}
          label={<FormattedMessage id={status === EDIT ? 'bank.save' : 'bank.edit'} />}
          onClick={status === EDIT ? props.handleSubmit(onSave) : onEdit}
          primary={status === EDIT}
          disabled={status === EDIT ? invalid : status === SAVING}
          icon={btnIcon}
        />
      </form>
    </Paper>
  );
};

EmployeeBankAccount.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  status: PropTypes.oneOf([EDIT, SAVING, FIXED]),
  account: PropTypes.object.isRequired,
  setStatus: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
};

EmployeeBankAccount.defaultProps = {
  status: FIXED,
};

export default flowRight(connect(
  (state, props) => ({
    form: `EBA-${props.account.EmployeeMasterBankID}`,
    initialValues: props.account,
    status: state.EmployeeBankReducer[`status-${props.account.EmployeeMasterBankID}`],
    bankBranches: state.EmployeeBankReducer.bankBranches,
    bankLedgers: state.EmployeeBankReducer.bankLedgers,
    validateBankAccount,
  }),
  dispatch => ({
    update: emb => dispatch(update(emb)),
    setStatus: status => dispatch(setStatus(status)),
  }),
), reduxForm({}))(EmployeeBankAccount);



// WEBPACK FOOTER //
// ./src/containers/pay/EmployeeBankAccount.js